import { render, staticRenderFns } from "./AccessibleSelect.vue?vue&type=template&id=497dfe4e&scoped=true"
import script from "./AccessibleSelect.vue?vue&type=script&lang=ts"
export * from "./AccessibleSelect.vue?vue&type=script&lang=ts"
import style0 from "./AccessibleSelect.vue?vue&type=style&index=0&id=497dfe4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497dfe4e",
  null
  
)

export default component.exports